import React, { useEffect, useRef, useState } from "react";

import "./course.overview.cmp.scss";
import courseComander from "../../../store/commanders/course.comander";
import { Line } from "rc-progress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CircularProgressCmp from "../../common/progressbar/circular.progress.cmp";
import { PrintableCertificate } from "../../certficate/certificate";
import CourseSurveyCmp from "../course.survey/course.survey.cmp";
import ModelCmp from "../../model/model.cmp";
import PLButton from "../../common/button/PLButton";
import { formatCertificateDate } from "../../../helpers/date.helper";
import { useTranslation } from "react-i18next";

const UserCertificate = ({ certificate, userName, state }) => {
  const completedDate = formatCertificateDate(certificate.comp_date);

  return (
    <div className={"user-certificate-row"}>
      <div>{completedDate}</div>
      <div className="print-user-cert-container">
        <PrintableCertificate
          courseStatus={"pass"}
          userName={userName}
          state={state}
          completedDate={completedDate}
          className={
            "print-user-cert cf-navbar__links--link cf-navbar__links--link-primary"
          }
          hideIcon={true}
        />
      </div>
    </div>
  );
};

const CourseOverviewCmp = ({
  selected,
  userName,
  state,
  onSelect,
  showFeedbackForStudent,
  showCongrats,
  submitFeedback,
  userCertificates,
}) => {
  const { t } = useTranslation();
  const [showFeedback, setShowFeedback] = useState(false);
  const surveyRef = useRef(null);
  const modules = Array.isArray(selected?.children)
    ? selected.children.filter((item) => item?.type === "module")
    : [];
  const totalModules = modules.length;
  const completedModulesCount = modules.filter(
    (module) => module?.finish || module?.status === "pass",
  ).length;
  const completedModulesPercent =
    totalModules > 0 ? (completedModulesCount / totalModules) * 100 : 0;

  const renderModuleResult = (course, onSelect) => {
    return course.children.map((module) => {
      const icon = module.status == "pass" ? "check" : "ban";
      const color = module.status == "pass" ? "var(--color-success)" : "var(--primary)";
      return (
        <div className="module-content" key={module.id}>
          <button
            type="button"
            className="module-content-title"
            onClick={() => onSelect(module)}
          >
            {module.title}{" "}
          </button>
          <div style={{ margin: 10, width: 400 }} className="d-md-block d-none">
            <Line
              percent={module.grades ? module.grades : 0}
              trailColor="silver"
              strokeWidth={4}
              trailWidth={4}
              strokeColor={color}
            />
          </div>

          <div className="text-center">
            <FontAwesomeIcon
              size="2x"
              icon={icon}
              className="icon"
              color={color}
            />
          </div>
          <div style={{ margin: 10, color: color, width: 50 }}>{` ${
            module.grades ? module.grades : 0
          } %`}</div>
        </div>
      );
    });
  };

  return (
    <div className="text-center marks-bg">
      {/* {renderNotification()} */}

      {showFeedback && selected && selected.id ? (
        <ModelCmp
          name={t("course.feedback")}
          bodyComponent={
            <CourseSurveyCmp
              innerRef={surveyRef}
              courseId={selected.id}
              submitFeedback={submitFeedback}
              afterSubmitting={() => setShowFeedback(false)}
            />
          }
          onCancel={() => setShowFeedback(false)}
          onSend={() =>
            surveyRef.current.dispatchEvent(
              new Event("submit", {
                cancelable: true,
                bubbles: true,
              }),
            )
          }
          sendButtonText={t("course.submitFeedback")}
          cancelButtonText={t("course.goToDashboard")}
        />
      ) : null}

      <div className="module-title">{t("course.dashboard")} {selected.title}</div>

      <div className="module-description">{selected.description}</div>
      <div className="course-summary-content">
        <div style={{ maxWidth: 300 }}>
          <CircularProgressCmp
            grades={completedModulesPercent}
            text={`${completedModulesCount}/${totalModules}`}
            status={selected.status ? selected.status : 0}
          />
          <div className="module-title mt-4">
            {t("course.modulesComplete", {
              completed: completedModulesCount,
              total: totalModules,
            })}
          </div>
        </div>

        <div className="course-completion-container">
          <div className="course-status">
            {selected.status == "pass"
              ? t("course.completedStatus", {
                  completedDate: formatCertificateDate(selected.last_completion),
                  expirationDate: formatCertificateDate(selected.expiration_date),
                })
              : t("course.inProgress")}
          </div>

          <div className="mt-4">
            <PrintableCertificate
              courseStatus={selected.status}
              userName={userName}
              state={state}
              completedDate={formatCertificateDate(selected.last_completion)}
            />
          </div>
        </div>

        {userCertificates && userCertificates.length ? (
          <div className="cert-history">
            <h3>{t("course.certificateHistory")}</h3>
            {userCertificates.map((certificate) => (
              <UserCertificate
                key={certificate.id || certificate.comp_date}
                certificate={certificate}
                userName={userName}
                state={state}
              />
            ))}
          </div>
        ) : null}
        <div className="module-button-container">
          <PLButton
            onClick={() => {
              courseComander.ac_next_lesson();
              courseComander.cmd_update_lastSeen(selected.id);
            }}
            variant="primary"
            size="lg"
          >
            {t("course.resume")}
          </PLButton>
          {selected && selected.status === "pass" && showFeedbackForStudent ? (
            <PLButton
              onClick={() => {
                setShowFeedback(true);
              }}
              variant="secondary"
              size="lg"
              className="ml-4"
            >
              {t("course.giveFeedback")}
            </PLButton>
          ) : null}
        </div>
        <div className="results-container">
          {renderModuleResult(selected, onSelect)}
        </div>
      </div>
    </div>
  );
};
export default CourseOverviewCmp;
